import axios from 'axios';
import {BACKEND_URL} from "@/constants/globalConstants";

const axiosServices = axios.create({ baseURL: BACKEND_URL });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
    async (config) => {
        const accessToken = localStorage.getItem('sessionToken');
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosServices.interceptors.response.use(
    (response) => response,
    (error) => {
        if (axios.isCancel(error) || error.code === 'ERR_CANCELED') {
            return Promise.reject(error);
        }

        const errorData = error.response?.data || 'Wrong Services';
        const httpStatus = error.response?.status;

        if (errorData && typeof errorData === 'object') {
            errorData.status = httpStatus;
            return Promise.reject(errorData);
        }

        return Promise.reject({
            status: httpStatus,
            message: errorData
        });
    }
);

export default axiosServices;

export const fetcher = async (args) => {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosServices.get(url, { ...config });

    return res.data;
};

export const fetcherPost = async (args) => {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosServices.post(url, { ...config });

    return res.data;
};